export const work = [
  {
    "folder": "uncertain-weathers",
    "name": "into uncertain weathers",
    "tags": "",
    "year": "2025",
    "thumb": "1.jpg",
    "content": `
    Work-in-progress created while an artist-in-residence at <a href="https://www.culturehub.org/events/into-uncertain-weathers" target="_blank">CultureHub NYC</a>.
 <i>into uncertain weathers</i> is an interactive installation and divinatory performance of poetry, weather balloons, mylar and haze which asks: What are technology’s affordances and limits in future-telling? 
 Despite state attempts to know and control the planet, we know that knowledge alone isn’t enough to secure our climate future. Inspired by Hito Steyerl’s How Not to Be Seen and Zhanyi Chen’s satellite poetry, the performance thinks about planetary imagery through a surveillance studies lens. 
Watch the recording → <a href="https://vimeo.com/1121613009" target="_blank">LINK</a>

    [ji-hoon-9.jpg]
     [7.jpg]
     [ji-hoon-7.jpg]

      [1.jpg]
      [ji-hoon-6.jpg]
      [semin-1.jpg]

    [ji-hoon-0.jpg]
    [semin-2.jpg]
    [ji-hoon-8.jpg]

<br>
<li>experiments in telepresence</li>
    During the event, the audience can ask questions both online and in-person—only to receive cryptic answers modulated by a NYC weather API and accompanied by NASA satellite imagery. The resulting texts will morph alongside temperature, wind, rain, and other vectors of fortunetelling. 
This project was also an experiment in expanding audience telepresence online; I used CultureHub's new software-in-development, their LiveLab Broadcaster, to build out audience interactions in p5.js which could overlay a low-latent video stream. Here are some view from online:
    [broadcast1.jpg]
<br>
    Audience members could overlay drawings, clouds, rain which would affect the performance in real time. thank you to Jonathan for the screenshots! 
    [broadcast4.jpg]
    [broadcast3.jpg]
    [broadcast2.jpg]

[broadcast6.jpg]
    The weather divination session ends when enough cursors congregate around the center of the sky, and create a fully white "eclipse" in the projection space.



<br>
<li>meteorological glyphs</li>
A set of glyphs drawn from meteorological symbols, turned into a custom typeface used for balloons, and for looping ground film projected through haze. 

[ji-hoon-5.jpg]


    [5.jpg]
    [glyphs.gif]
[type3.jpg]
   <br>
  
<li>WEBSITE + ZINES</li>
You can still access the divination website here → <a href="https://www.uncertain.cloud/" target="_blank">LINK</a>
 <iframe src="https://player.vimeo.com/video/1123723725" frameborder="0" width="100%" height ="320"></iframe class="video">
After the show, I turned all participant questions into little zines which repurposed the mylar from the balloons. 
[zine-culturehub.jpg]
[zine3-edit.jpg]
<br>

       <li>credits</li>
           HUGE thank you to the CultureHub team: DeAndra, Mattie, Sangmin, Tee, Billy, and all! Special thanks to Lai Yi Ohlsen for the projector loan, and to Willy Wu for backend support. Big thanks also to Ryan Greene for testing.

 Thank you so much to Ji-Hoon Kim and Semin Lee for your photos, and for your work documenting the event! Photo credit for other in-person images go to dear friends Angie and Livia—thank you.
 Thank you to Katherine Yang for <a href="https://www.culturehub.org/read/what-is-a-cloud">writing about this performance</a>.

 If you are featured in these photos as an attendee but don't want to be, please reach out and I will take it down.
`
  },
  {
    "folder": "weaves",
    "name": "scintillations",
    "tags": "",
    "year": "2025",
    "thumb": "somad-3.jpg",
    "content": `
            Scenes from Sewell, Chile: the largest underground copper mine and its American company town.
            Inkjet on cotton, digital embroidery. 24 * 18 inches. Shown at SoMad Gallery, New York, April 2026, as part of Intersectional Ecologies.


            [infinite.JPG]
            [metalis.JPG]
            <br>

            Open-pit series, Southern Arizona. Inkjet on cotton, copper sheeting. 12 * 16 inches.    
            [weave1.jpg]
    
            [weave2.jpg]
            [weave3.jpg]

            <br>
            On show at SoMad Gallery, NYC. Photo credit to Yi Hsuan Lai.
            [somad-2.jpg]
       `},

  {
    "folder": "no-object",
    "name": "there is no mineral of futurity",
    "tags": "",
    "year": "2023",
    "thumb": "thumb.jpg",
    "content": `Cyanotype on cotton and paper, approx 30 inches square. 
    The piece depicts error screens, cursors, glitches, alongside mining sites in Google satellite imagery and settler colonial cartographies. Among these are lithium mines in the American Southwest and cobalt mines in the Congo, both of which are crucial for battery production; the piece’s geographies also include a 19th century map of the largest copper mine in the world, based in Chile, which played a critical role in the dawn of electricity and electronics. 
  These cyanotype images were developed using solar power and iron-based pigment, which nods to photography’s material basis. Perhaps there is something about photography which pretends to be virtual as well, which creates what Susan Sontag calls a “fracturing, dislocating vision that only the camera supplies.” 
  
  [no-object.png]
  [7.jpg]
  [3.jpg]
  [17.jpg]
  [6.jpg]



`

  },


  {
    "folder": "image-of-a-horse",
    "name": "image of an image",
    "tags": "",
    "year": "2026",
    "thumb": "b1.jpg",
    "content": `  
  Work in progress! Created as a workspace artist-in-residence at the Center for Book Arts. Edition of 20.

  a RISO printed woven accordion book of ekphrastic poems-in-progress by the artist, kathy wu; Found and manipulated compositions from Google Open Images v7 data set sit alongside Muybridge's Untitled (Horse + Jockey) — a nod to Rebecca Solnit's book, River of Shadows, which swirls together Muybridge's early photography of California with present day Silicon Valley expansionism. 
[w1.jpg]
[w2.jpg]
[w0.jpg]
[w3.jpg]
  [w6.jpg]
  [w4.jpg]
  [w5.jpg]
  [w7.jpg]
`

  },
  {
    "folder": "field",
    "name": "a field",
    "tags": "",
    "thumb": "altthumb3.jpg",
    "year": "2025",
    "content": `
    Work-in-progress from my time at Black Mountain College Museum + Art Center. A large drawing, projected video, and movement performance situated in the original Black Mountain College Studies building.
    Graphite on cotton muslin, sticks, reeds, video, poems.

            <iframe src="https://player.vimeo.com/video/1131542204" style="background:black; width:100%; height:400px; border-radius:4px" frameborder = "0" allow="fullscreen" allowfullscreen></iframe class="video">

    <li>surface</li>
    [day.jpg]

    [4.jpg]
    [5.jpg]
    [10.jpg]

        <li>movement</li>

        [movement0.jpg]
        [movement1.jpg]
        [movement5.jpg]
<br>
        The movements were based on a traditional writing grid—the "rice grid."
        [grid.jpg]


  `
  },

  {
    "folder": "she-will-last",
    "name": "she will last as long as stones",
    "tags": "",
    "year": "2024–2026",
    "thumb": "thumb.jpg",
    "content": `
Book of visual poetry on themes of geology, computation, migration, and loss. Design by Dorothy Lin, edited by Corinne Butta. Printed in an edition of 1,000. Published by <a href="https://wendyssubway.com/publishing/titles/she-will-last-as-long-as-stones" target="_blank">Wendy's Subway Press.</a>
  [cover.jpg]
  [03-flat.jpg]
  [06-flat.jpg]
  
    <li>performances</li>
    Photos from book tour in 2025–2026! Videos by Amelia Doll. 
    [wendys.jpg]
    <iframe src="https://player.vimeo.com/video/1160585792" frameborder="0" width="100%" height ="350"></iframe class="video">
    <iframe src="https://player.vimeo.com/video/1160585890" frameborder="0" width="100%" height ="350"></iframe class="video">
    <br>
Multimedia element from performances—
    <iframe src="https://player.vimeo.com/video/1160624808" frameborder="0" width="100%" height ="320"></iframe class="video">
    <li>early version</li>

 Originally, the work was performed as MFA thesis project for Brown University Literary Arts program, 2024. Advised by Sawako Nakayasu. 
A huge thank you to Si-Min Chong for taking these photos/video!

  [still5.jpg]
  [still1.jpg]
  [still3.jpg]
 <iframe src="https://player.vimeo.com/video/947107796" frameborder="0" width="100%" height ="320"></iframe class="video">
    <br>
`
  },


  {
    "folder": "homonym",
    "name": "homonym",
    "tags": "",
    "year": "2025",
    "thumb": "crop.jpg",
    "content": `
          Jacquard-loomed hanging of my mother's circuitry. Cotton, 50 * 60 inches.
          [crop.jpg]
          [detail5.JPG]
          [detail2.JPG]
          [detail7.JPG]

      `},



  {
    "folder": "cyan",
    "name": "on cyan",
    "tags": "",
    "year": "2023",
    "thumb": "4.jpg",
    "content": `  
  <i>on cyan</i> is an artist book of poetry which fixates on the perceptual, the optical, through the lens of color names. It refracts, it stalls, it attempts to match paint and paper to air. When folded out, the poem becomes a cyanometer, transparent and with swatches of blue descending in brightness.

  Perhaps in a medley of abstract plein air painting, field study, and poetry, the poem meditates on and tries to critique science figures like Alexander Humboldt (who sought to <a href="https://www.lrb.co.uk/the-paper/v41/n04/joyce-chaplin/blues-of-many-skies" target="_blank">measure the blue of the sky.</a>) It reflects on natural world’s capacity within as well as how it suffers from naming; the way dissections are incomplete and faltering; the complexity of everything even air refracting blue light. 

  Made of acetate, mirrored plexiglass, gouache on bristol.

  [1.jpg]
  [8.jpg]
  [3.jpg]
  [4.jpg]
  [5.jpg]
  [2.jpg]
<br/><br/>
  <li>performance</li>
  Video component made with p5.js, voice.
  <iframe src="https://player.vimeo.com/video/781114238?h=0bb978ccb6" frameborder="0" width="100%" height ="320"></iframe class="video">
`

  },


  {
    "folder": "virtual-blue",
    "name": "virtual blue",
    "tags": "HTML, javaScript, projection, sound, poetry",
    "thumb": "blue2.gif",
    "year": "2021",
    "content": `
Published in Fonograf Edition's <a href="https://fonografeditions.com/catalog/fono31-de-canon-fe-a-mouth-holds-many-things-print-anthology/" target="_blank">A Mouth Holds Many Things</a>. If you call something, you can keep it in a box. If you classify it, perhaps you can harvest it. Commodification and supply chain and frameworks of extraction have their own grammars.
Shown at Emerson Contemporary, March 2026, as part of <a href="https://emersoncontemporary.org/event/messing-with-language-a-multimodal-pop-up-exhibition/" target="_blank">Messing with Language</a>. Photos courtesy of Sophie Dodd.
[emerson6.jpeg]
[emerson7.jpeg]

This infinitely looping browser poem explores concepts both abstract and concrete — a color wavelength — are socialized through language. How blue was the last discrete color category to be named in English.

Watch with sound on:
<iframe src="https://player.vimeo.com/video/651241191" width="100%" height="350" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe class="video">
Website → <a href="https://kaaathy.com/blue/index.html" target="_blank">virtual blue</a> (images may load slowly before they cache)
<br><br>

  Virtual loves to hide a supply chain. They can't make lithium fast enough.
  [blue0.gif]

  Appliances love to hide a hole. Cobalt is the sound on the roof of your mouth.
  [blue2.gif]

  Vermeer finds beautiful clothing for Mary. She's draped in it, it's Afghanistan.
  [blue6.gif]

  They wanted to build a tunnel to China but China was busy eating the Congo.
  [blue3.gif]

  The glaze whispering, infinity. You think blue is velvet but it is made of hard things.
  [blue4.gif]

<br>
  Color names poem projected onto a ceiling:
  <iframe src="https://player.vimeo.com/video/650982362" width="100%" height="396" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe class="video">
  [blueceiling.jpg]

  The data:
  [bluelist.jpg]

  `
  },



  {
    "folder": "cloudpoem",
    "name": "when will it rain",
    "tags": "javascript, HTML, poetry",
    "year": "2023",
    "thumb": "thumb.jpg",
    "content": `A webpoem about balloons and meteorology and unidentifiable objects, about the limits of knowing and seeing, how governments and states know and see.
    Procedurally redacts/translates things into the word "object," folds in live weather from government data. 
    Read online → <a href="https://kaaathy.com/cloud/index.html" target="_blank">LINK</a>
    [cloudpoem.gif]

    `
  },
  {
    "folder": "bisbee",
    "name": "Bisbee",
    "tags": "weaving",
    "year": "2026",
    "thumb": "0-alt.jpg",
    "content": `
    Wool, cotton, and copper-leafed paper on copper wire warp. Better pictures coming soon (maybe!)
    Thank you <a href="https://www.emmanuelfernandoserrano.com/" target="_blank">Fernando Serrano</a> for the dyed blue churro and copper leaf <3

    [0-alt.jpg]
    [4.jpg]
    [7.jpg]
        [5.jpg]

    [weave5.jpg]



    `
  },



  {
    "folder": "weeds",
    "name": "the color of dislocation ii",
    "tags": "",
    "year": "2023",
    "thumb": "3.jpg",
    "content": `
<i>the color of dislocation (weeds now run wild)</i> is a textile series concerned with sheerness, opacity, and color in classification systems. I wonder at how scientific language grasps at knowledge; precisions it; pins it as a colonial found. Perhaps poetic gestures of annotation and collage introduce fog instead, and trouble the body of water which represents “scientific” epistemology.. 
        The following banners contain language written by me as well as “found” text from Darwin’s HMS Beagle Voyage records.
   
     <li>fiber component</li>

    [3.jpg]
    [5.jpg]
    [7.jpg]
<br/>
  The first banner was made in the winter:
  [anobject2.jpg]


`

  },


  {
    "folder": "stone-shirt",
    "name": "want to not want the heavy",
    "tags": "",
    "year": "2023",
    "thumb": "shirt.jpg",
    "content": `
  A cold, 15-pound garment stitched together with Rhode Island river and beach stones. This garment is worn during the computer performance as an expression of embodied grief, and as an extension of the local ecologies. 
  
  [shirt.jpg]
  [detail.jpg]

  Here, I'm modeling it by the Blackstone Seekonk river, which was, at one point, the most polluted river in the country due to Pawtucket textile industries. (Thank you, Riley, for this picture in below freezing windy weather).
  [river.jpg]
<br>
  Accompanying quilt-object—
  [quilt.jpg]
`
  },
  {
    "folder": "stope",
    "name": "stope",
    "tags": "",
    "year": "2025",
    "thumb": "detail2.jpg",
    "content": `
<i>stope</i> is an artist book compiling photography from copper mining sites: Bisbee and Sahauritas, Arizona, and Sewell in Chile. Set in "copper green," nodding at oxidation and malachite deposits found in these areas, the monochrome book also alludes to industries' increased reliance on copper for so-called green technologies.
The sheer book lends a thread of connectivity between these related sites of violence, using both found text and photography to "conduct," as copper does, a salient thread across continents.            Inkjet on organza.
            [spread1.jpg]
            [spread2.jpg]
      [spread4.jpg]

<br>
<li>Detail</li>
            [detail0.jpg]
            [detail1.jpg]
            [detail2.jpg]
            [detail4.jpg]
             [cover1.jpg]

                                   

        `},
  {
    "folder": "fossils",
    "name": "litany for the ground (fossils)",
    "tags": "",
    "year": "2025",
    "thumb": "somad1.jpg",
    "content": `
          Multi-media body of work thinking through the "geology of media," as defined by theorist Jussi Parrika, and via the forms of litanies and list poems. Sculptures of sand, rockite, vintage hardware, data / website of poems, 3D scans / installation of stone, digital fabric print.
          [somad1.jpg]
        [somad2.jpg]
          [somad3.jpg]
        [somad4.jpg]
          Images from SoMad Gallery, NYC. April 2026. Thank you to Yi Hsuan Lai for the photos.
          
<br>
          <li>sculptures</li>
          These objects are extensions of the <a href="http://kaaathy.com/work/she-will-last/iphone.jpg" target="_blank">cement casts</a> I made in Spring '24. Plus SD cards, USB-C, vintage NOKIA phone. These works are very much inspired by Blair Simmons's <a href="https://www.blairsimmons.com/">laptop-in-cement</a>!
          [mirror2.JPG]
          [invert.jpg]
          [mirror7.JPG]
          [iphone.jpg]

          <br>
          <li>webpoem</li>
          Accompanying website for unearthing fossilids. Made with three.js, matter.js. 
                    Read the web component → <a href="http://kaaathy.com/fossils" target="_blank">LINK</a> 

[web.jpg]

[spin.gif]
[falling.gif]
[forget.gif]

<br>
<li>data</li>
A stone and a fraction of the .txt file for its 3D digitized self. Inkjet on cotton, 3 inches * 20 feet.
[install1.JPG]
[rock-comp.gif]
[txtscan1.jpg]
<br>

<li>object details</li>
USB, USB-C, SD card... I give credit to the brilliant Mika Ben Amar <a href="https://www.instagram.com/100o111/" target="_blank"> who made usb stones first.</a> 
          [usb_b2.JPG]
          [mono5.JPG]
         
         <br>USB with the encoding of its own 3D image—
          [usb.JPG]

      `},

  {
    "folder": "dwell",
    "name": "dwellings",
    "tags": "fiber",
    "year": "2026",
    "thumb": "6.jpg",
    "content": `
          Work in progress. Soft computers with NFC tags. They're siblings.
             [7.jpg]
             [9.jpg]
             [10.jpg]
             <br>
             NFT tags in the lower corner of each pillow leads you to a text-based dream sequence.
             [aftermath-small.gif]
             [readingful-small.gif]

                <iframe src="https://player.vimeo.com/video/1202338930?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="100%" height="375" frameborder="0" allow="autoplay;  title="aftermath"></iframe>
<br>
                Perhaps they can offer a place to rest...
                [1.jpg]
           [3.jpg]
                      [4.jpg]
               
[5.jpg]


      `},
  {
    "folder": "aa-abolition",
    "name": "visioning towards abolition",
    "tags": "zine, workshop",
    "year": "2026",
    "thumb": "10-alt.jpg",
    "content": `
           <li>2026 edition</li>
  Second edition of an Abolition Zine for 2026. Produced by <a href="https://printingfortunes.info/Many-Folds-Press-1" target="_blank">Many Folds Press</a>, designed in collaboration with Angela Chang and Many Folds. 75% of proceeds go towards deportation defense funds.
      Bisque and Blue RISO ink on Salmon text weight paper by French Paper.

      [cover-alt.jpg]
      [2.jpg]
      [3.jpg]
      [5.jpg]
      [6.jpg]
      <br><br>

      Buy from Many Folds press! <3 → <a href="https://printingfortunes.info/product-page-abolition-zine" target="_blank">LINK</a>
      [mfp1.jpg]
      [mfp2.jpg]
      Photos by Connie Yu.

       <li>2021 edition</li>

          Made with <a href="https://www.aarw.org/" target="_blank">Asian American Resource Workshop</a> (AARW) as part of their abolition working group. Includes a political educator's toolkit to run this in your own communities. Distributed online through AARW as well as through <a href="https://pm.linkedbyair.net/catalog/59883/" target="_blank">Printed Matter</a>.

          [zine-scan-cover-2.jpg]
          [2-old.jpg]
          [3-old.jpg]
          [4-old.jpg]
          [zine-scan-slow.gif]
          <br>
                  Use the workshop toolkit → <a href="https://docs.google.com/presentation/d/1pfmC3wtc6xU0QqKWCPTugfl0HUkxZXpLT9-772c-Ndo/edit#slide=id.g10d7d2d8eac_0_155" target="_blank">LINK</a> 

          [slide1.jpg]
          [slide2.jpg]

      `},

  {
    "folder": "conducting-memory",
    "name": "Conducting Our Memory",
    "tags": "zines, workshop",
    "year": "2026",
    "thumb": "makey2.jpg",
    "content": `
    Conductive zines made for a workshop in the historical mining town of Bisbee, AZ. Participants used <a href="https://chibitronics.com/" target="_blank">Chibitronics</a> and <a href="https://www.youtube.com/watch?v=rfQqh7iCcOU" target="_blank">MaKey MaKey</a> to create simple circuits with copper on paper. The zines have prompts for drawing and writing, and share past and present struggles around copper mining—for example, the 1917 Bisbee Deportation of striking miners, and today's fight to protect sacred land from mining companies.
    Shown at Ulises Project Space, April 2026.
    
    [cover.jpg]
    [makey3.jpg]
           [poem1.jpg]

          [spread5.jpg]
         [spread6.jpg]
            [spread3.jpg]
                [spread1.jpg]
     [spread2.jpg]

         [cover-lit.jpg]

   [closeup.jpg]
   Created while Artist-in-Residence at Bisbee Central School Project. Special thanks to Laurie McKenna, Fernando Serrano, Ryan Greene.
  <br>
   Images from workshop + process—
   [process.jpg]
   [workshop.jpg]
   [wr-1.jpg]

   <br>
   In Ulises Project Space as part of :/repair. Photos by Ian Byers-Gamber.

    [gallery2.jpg]
          [gallery1.jpg]
[gallery0.jpg]

    `
  },




  {
    "folder": "potters-fields",
    "name": "satellite drawings",
    "tags": "",
    "year": "2021",
    "thumb": "drawing1.jpg",
    "content": `
    Colored pencil drawings of former burial sites in NYC which are now public parks (or pending transformation in to a public park).

    [drawing1.jpg]
    [drawing2.jpg]
    [drawing3.jpg]

    <br>
    <li>detail</li>
    [detail1.jpg]
    [detail2.jpg]

`

  },

  {
    "folder": "eroevent",
    "name": "erotic event listeners",
    "tags": "",
    "year": "2022",
    "thumb": "1.jpg",
    "content": `
    Included in <a href="https://criticalcode.recipes/" target="_blank">Critical Coding Cookbook: Intersectional Feminist Approaches to Teaching and Learning</a>, via The New School.

    This workshop is inspired by a tradition of computational & digital poetry, as well as by feminist writers who write about love, pleasure, and healing. This is a template and starting point for building a simple digital love poem focused on opacity/transparency, and click/touch interactions.

Within the traditions of material and concrete poetics, we might gently resist what this web space might be for.
[1.jpg]
[3.jpg]
[5.jpg]
[4.jpg]

<br>
Website with a simple template for a digital erotic poem:
 → <a href="https://kaaathy.com/erotic-event-listeners/" target="_blank">Erotic Event Listeners</a>
    [web1.png]
    [web3.png]
        [rose.gif]
    [code.jpg]
    `
  },
  {
    "folder": "future-making",
    "name": "Future Making: DS4SI",
    "tags": "",
    "year": "2026",
    "thumb": "thumb.jpg",
    "content": `
        I was invited by Design Studio for Social Intervention to run a 3-hour workshop for their series, Momentum Lab. Thank you Anulfo and Crystal for having me! <3

    <i>Future Making: Collective Scrying, Sensing, Dreaming</i> was a co-imagining space to hold each other in the midst of state violence, climate crisis, and general moments of uncertainty. The session included divination experiments where we create our own modes of prediction — inspired by ancient modes of future-telling such as scrying, weather-based divination, tea leaves. 
    To end, we made a collective tarot card deck of our co-imaginings.   

Thank you to Celine Berger for the photos! If you are in a photo and no longer want to be, please reach out to me and I will take it down.
[event3.jpeg]
I asked participants to think about something they want to ask the ancestors, and what they'd like to tell the descedants. Together we looked at the artwork of Skawennati and the words of Octavia Butler.
        [event4.jpeg]
        [slide5.jpg]
        A colorful slide with an Octavia Butler quote: "There’s no single answer that will solve all of our future problems. There’s no magic bullet. Instead there are thousands of answers–at least. You can be one of them if you choose to be."
   <li>divination play</li>
   Folks were invited to try modes like ceromancy (with wax), bibliomancy (with books), taseomancy (tea leaves), or make up their own.
[candle2.jpeg]
[wax1.jpeg]
(What do you see in the wax?)
       <li>collective card deck</li>
Participants were given simple card templates to draw or collage on. These were the (optional!) prompts:
— One thing which makes you feel steady and sure
— One thing which makes you feel unstable but excited
— The kind of love you wish you could give a younger self
— An image/object/place from a dream
— Something your ancestors would do in hard times
[scan.jpg]
[event5.jpeg]
[event8.jpeg]
   Cards were scanned and printed and shared in different colors.
  [event7.jpeg]
                [event10.jpeg]
 [cards2.jpg]
[cards5.jpg]
  [cards3.jpg]
   [cardgif.gif]

  
      `},
  {
    "folder": "malden-zine",
    "name": "malden transit justice workshop",
    "tags": "zine, workshop",
    "year": "2021",
    "thumb": "a-voyce-zine-2.gif",
    "content": `
               A zine I co-created and designed with Asian-American teenagers in Malden, MA, as part of a creative and civic literacy afterschool program.
        I was the teaching artist for Malden's Asian Community Development Corp in the spring of 2021. 
        [malden.jpg]
        Together, we discussed how transit justice is also economic, environmental, and racial justice. I shared local histories of resisting displacement, as well as the beauty and power of maps and "countercartographies," which we made together. Students shared some of their ideas for a better Malden with the city council, as well as through their artwork, which is featured in this zine.

        Learn more about Malden A-VOYCE <a href="https://asiancdc.org/sy-malden2122" target="_blank">here</a>.

        [malden1.jpg]
        [malden8.jpg]
        [malden7.jpg]
        [a-voyce-zine-2.gif]
        
        `
  },
  {
    "folder": "walk",
    "name": "walking with ghosts",
    "tags": "Interactive, HTML",
    "year": "2021",
    "thumb": "thumb.jpg",
    "content": `<i>walking with ghosts</i> is a hypertext web poem that invites the reader to travel through cryptic sites in Google Street View. the images are pulled from current NY public parks (nearly all of which used to be potter's fields) and contrasts present day burial grounds with these recreational spaces.
  it nods at the historical layers of eviction, theft, imperialism embedded quietly and namelessly in these green spaces, via the narrative throughline of ghosts.
  Read online → <a href="https://kaaathy.com/walk/1.html" target="_blank">LINK</a>
<iframe src="https://player.vimeo.com/video/596956749" width="100%" height="396" frameborder="0" allow="autoplay; fullscreen"  allowfullscreen></iframe class="video">
  [walk1.png]
  [walk2.png]
  [walk3.png]
  [walk4.png]
`
  },

  {
    "folder": "internetgeo",
    "name": "internet geology",
    "tags": "Mixed media, data, projection, sound, poetry",
    "year": "2022",
    "thumb": "vid-short.gif",
    "content": `
  Internet Geology is a multimedia installation which highlights geographic sites of copper extraction and outlines the role of copper in technology and internet infrastructures. 
  
  Inspired by Fernando Godoy’s copper mine recordings, Trevor Paglen’s drone footage project, and Sam Lavigne’s web scrape of oil news, the digital projection combines sound, maps, government data, and poetry to play with the aesthetics of systemized extraction and "the field." 
  <iframe src="https://player.vimeo.com/video/778307297?h=7132e13db1&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="100%" height="396" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe class="video">

  The installation combines the satellite’s gaze (via OpenMapBox) and Open Mineral data from US governmental data bases on worldwide copper mines, smelters, and plants. This piece is projected on to a copper-infused, copper-colored conductive fabric. 
   [geostill.jpg]
 [action.jpg]
  [one.jpg] 

In front is a metaphorical "circuit" of objects: a sculptural installation of yarn, selvage circuitry, smart phone, found natural materials, and copper tape. Touching part of the sculpture closes the circuit and subtly manipulate the projection & sound.
  [topview.jpg]


  Made with found objects, copper, Leaflet.js, Mapbox, Tone.js, with thanks to Freesound.org user Travis Needham. 

`

  },

  {
    "folder": "semiconduction",
    "name": "Touching Each Other Through Semi Conduction",
    "tags": "Interactive, HTML",
    "year": "2021–3",
    "thumb": "semi6.gif",
    "content": `A two-part poem diptych between screen-based work and artist book. Reflections on supply chain, migrant labor, Foxconn, diaspora.
    <br>
    <li>artist book</li>
    [companion1.jpg]
    [companion2.jpg]
    <br>
    <li>digital poem</li>
    An <a href="semiconduction/index.html" target="_blank">interactive web poem</a> I wrote and coded about Chinese workers in a context of mass production.
    Works on mobile. As seen in <a href="https://thenewriver.us/" target="_blank">New River's Fall 2022</a> publication. For a more spatial viewing experience, try on a desktop computer.
     [semi6.gif]

     Still image:
     [semi_crop.jpg]

    <br>
 
    `
  },

  {
    "folder": "looting",
    "name": "Looting Dream",
    "tags": "Interactive, HTML",
    "year": "2021",
    "thumb": "thumb.jpg",
    "content": `An interactive web fantasy about distorting, glitching, re-inserting, and deleting from glass boxes + institutions. Seen on <a href="https://pages.virtualgoodsdealer.com/exhibits" target="_blank">Virtual Goods Dealer</a>.
     Read online → <a href="https://kaaathy.com/everything/looting-dream.html" target="_blank">LINK</a>
[looting.gif]
   [looting.jpg]


   `
  },
  // {
  //   "folder": "person-object",
  //   "name": "person [object]",
  //   "tags": "",
  //   "year": "2023",
  //   "thumb": "thumb2.jpg",
  //   "content": `Artist book & poems about human labor within today's computational systems: content moderators in SE Asia who flag traumatizing content before it ever reaches our screens; low wage Amazon crowdsourced labor all over the world; low wage human subjects who help train our AI systems, including transcribing Alexa and other home assistant conversations.

  //   Workers must often make decisions in "blurry" spaces, where machines are likely to make a mistake; they complete microtasks for little money with minimal labor protections; meanwhile their existence remains ghostly and un-rendered to rest of the world.

  //   [0.jpg]
  //   [1.jpg]
  //   [2.jpg]





  // `

  // },
  // {
  //   "folder": "a-cell",
  //   "name": "A CELL, A CELL",
  //   "tags": "",
  //   "year": "2023",
  //   "thumb": "sadthumb.jpg",
  //   "content": `An artist's book of short expiermental poems about the bureaucracy of end-of-life care, of diaspora and loss.
  //   Better documentation coming soon (maybe).

  // [crop.jpg]
  // [one.jpg]
  // [crop2.jpg]
  // [two.jpg]
  // [crop3.jpg]
  // [three.jpg]
  // `

  // },
  {
    "folder": "dp",
    "name": "The Byte Catalog",
    "tags": "installation, sculpture, writing",
    "year": "2015",
    "thumb": "thumb.jpg",
    "content": `
  RISD Degree Project, 2015. How much does the internet weigh? How much data do we consume? Are their landfills of information on the internet?
[intro_bytes_reduced.jpg]

  The Byte Catalog expresses the degree to which text in digital space is now so immense in scale, that our bodies fail to comprehend it. Language originally comes from the human body, and holds meaning within social, relational contexts. What happens at scale—when language transcends meaning, when data transcends body?
  This work began as a inquiry into the textual internet; over a semester, it evolved into a visceral experience of virtuality, including sculpture, video, and writing.

  <br><br>
  <li>volume, weight</li>

  If our informational input could be measured in pounds, imagine how it would feel to literally consume or hold that much weight.

  In early explorations, I translated data into sculptural objects with mass to expand the abstract idea of "gigabyte" or "terabyte," into a sensory one.

  [dp_1.jpg]
  <br>
  <br>
  <li>conversation tools</li>
  The human body understands the material world and has unique intuitions that help us navigate it. I was interested in how people would use intuition to convert their understanding of virtual units into physical objects.
I created interpretive “conversion tools” in the form of frames and boxes. Each of these symbolized a space for an assigned virtual unit where people’s responses/objects would live.
  [crowdsourced.jpg]


  <br>
  <br>
  <li>writing</li>
  Writing was an important part of my process and discovery. I generated about 1MB worth of text and images throughout this project. I populated that data into a <a href='https://drive.google.com/file/d/0BzXTWcuY86iYcHFTREVrbVhrRzA/view?usp=sharing
' target='_blank'>process document</a> and a video (below).
  In the Byte Catalogue, I documented objects I crowd-sourced. I compared these against virtual experiences—for example, the Lord of the Rings trilogy in bytes.
  [dp_2.jpg]
  {<video src ='work/dp/video_2.m4v' controls autoplay='on' muted width='98%' height='300' style='border:1px solid #e0e0e0'></video>}


  <br>
  <br>
  <li>ownership of virtual things</li>
  Inspired by the Million Dollar website, I was amused at the skeuomorph of buying “space” on the Internet.
  [7_alt.jpg]
  <br>
  I allocated pixel acre-age on my site for people to own, with a corresponding deed modeled after traditional land deeds.
  [dp_3.jpg]


  <br>
  <br>
  <span class="emph">virtual world</span>
  Eventually I collected enough to fill up a room with artifacts. I found textual objects and materials of different weights and densities and quantified them in bytes.
  The piece also featured sculptural metaphors like downloading across glass jars, as well as plastic physical hard-drives.
  [1.png]
  <br>
  [4.jpg]
  [3alt.jpg]
  `
  },

  {
    "folder": "digpo",
    "name": "digital poetics",
    "year": "2014–2015",
    "tags": "Poetics, digital media",
    "thumb": "thumb.png",
    "content": `
      By now, vintage experiments from the 2010's.
      The gesture of writing includes scratch, ping, swipe, tap. What are some new tools for writing that push or strain the body? These are experiments in bizarre and obstructed lingual gestures. 
      <br>
      <li>basho in the garden</li>
      [basho.png]
      [basho1.png]
      <li>CROSS-COUNTRY CALLIGRAPHY</li> It may take months to write to you.
      [driving_gif.gif]
      <br>
      <br>
      <li>TRANSCRIBING OBSTRUCTIONS</li> 
      Typing with socks on my hands.
      [socks.png]
<br>Reading tongue twisters while covering different parts of my mouth with a spoon. I used an online text-to-speech tool.
 <iframe src="https://player.vimeo.com/video/1161161194" frameborder="0" width="100%" height ="300"></iframe class="video">
      <br>
      <br>
  
      <li>KEYBOARD CALISTHENICS</li> A speculative guidebook and sarcastic keyboard workout video, inspired by Jane Fonda energy from the 80's and those horrible typing games from my childhood.
      [kindastrange1.gif]
      <br>
      Explorations in repetition, exercise, and creating writing from an interface-first perspective – since our expression is ultimately constrained by body and tools.
      <br>
      [keyboard1.png]
      [keyboard2.png]
      [keyboard3.png]
      `
  }

  //
  // {  "folder":"jelly",
  //   "name":"Pulmō Plastics",
  //   "tags":"Speculative objects, biodesign",
  //   "thumb":"overview.jpg",
  //   "content":`
  //
  //   Collaboration with biologist Marian Shaw as part of NYU ITP's Biodesign studio.<br>I contributed to the research, concept, storytelling, and writing.
  //   Selected as a finalist for the <a href="https://biodesignchallenge.org/" target="_blank">Biodesign Challenge</a>, and presented at MoMA in 2018.
  //
  //   [overview_crop.jpg]
  //
  //   As part of the man-made climate crisis, oceans are warmer and more acidic. Jellyfish, known as pulmōnēs in Latin, are <a href="https://www.youtube.com/watch?time_continue=21&v=uh4eImPI-OY&feature=emb_logo&ab_channel=HarvardUniversity" target="_blank">overpopulating</a> parts of global oceans.
  //   Proliferating in blooms, they <a href="www.thejakartapost.com/news/2020/05/01/workers-fishermen-scramble-to-fend-off-jellyfish-bloom-in-waters-off-east-java-power-plant.html" target="_blank">pose a threat</a> to human infrastructures, but more importantly, to biodiversity in the marine ecosystem.
  //
  //   [jelly-context.jpg]<span style="font-size:11px">Image copyright: Monty Graham, Dauphin Island Sea Lab // Getty Images</span>
  //
  //   When plastic enters the oceans, marine wildlife often confuse it for their jellyfish prey and subsequently die from plastic consumption.
  //     [jelly21.jpg]<span style="font-size:11px">Image credit: Troy Mayne, World Wildlife Foundation.</span>
  //
  //     What if we could close the loop between our jellyfish ‘problem’ and another marine threat— <span class="emph">petroleum-based plastic waste</span>?
  //
  //   [jelly3.jpeg]
  //   Jellyfish protein is almost exclusively <span class="emph">the structural protein collagen.</span> Given this 500-million year old creature consists of collagen of an earlier template in the evolutionary cycle, it has the potential to be a more universal biomaterial for various applications.
  //   We propose the use of <span class="emph">jellyfish gelatin</span> (which can be obtained by heating jellyfish collagen), <span class="emph">vegetable glycerin,</span> and <span class="emph">chitosan</span> to create food-safe, <a href="https://fabtextiles.org/the-secrets-of-bioplastic/" target="_blank">biodegradable plastics</a> which enter safely back into the ecosystem
  //
  //   [jelly9.jpeg]
  //
  //   <br>
  //   <br>
  //   <span class="emph">OUR PROCESS</span>
  //   We tested different ratios of glycerin to gelatin and plastic shape and size, creating samples with varying material properties that could lend themselves to different objects.
  //
  //   [jelly5.jpeg]
  //
  //   Crunchy like a disposable beverage bottle...
  //   [jelly6.jpeg]
  //   ...or supple yet strong like a ‘plastic’ bag.
  //   [jelly7.jpeg]
  //
  //   In our final samples, we dyed plastics with beet juice and incorporated pigments produced by bacteria engineered to express colorful proteins derived from marine animals.
  //   [jelly18.jpeg]
  //
  //
  //
  //   <br>
  //   <br>
  //   <span class="emph">FINAL THOUGHTS</span>
  //   Despite the current abundance of jellyfish, do we have the right to steal them — even dead ones — from nature for our material desires?
  //   [pulmo_samples.jpg]
  //   We recognize that creating new biomaterials is not a substitute for urgent <a href="https://en.wikipedia.org/wiki/Green_New_Deal" target="_blank">policy</a> towards real environmental justice. Nor do we want to encourage future cycles of exploitation of abundance in order to deplete it.
  //   Our hope with this work is to illustrate effects of unsustainable supply chains on the ocean today — and to ask the audience to imagine how materials we use in the future can be more interoperable with our biological planet.
  //
  //
  //   `
  // },




] as const